import React from "react";
import Link from "next/link";

import { Strain } from "custom-types/Strain";
import { useEventTracker } from "hooks/useEventTracker";

import ButtonPlaceholder from "components/ButtonPlaceholder";

type Props = {
  strain: Strain;
  hasMenuItems?: boolean | undefined;
  trackingCategory: string;
  trackingAction: string;
  trackingLabel: string;
};

const StrainCardAccessoryTray: React.FC<Props> = ({
  strain,
  hasMenuItems,
  trackingCategory,
  trackingAction,
  trackingLabel,
}) => {
  const { publishEvent } = useEventTracker();
  return (
    <div className="m-md mt-none">
      {hasMenuItems === true && (
        <Link
          href={`/search/shop?shopCategory=strain&shopName=${encodeURIComponent(
            strain.name,
          )}`}
          data-testid="strain-card-strain-buy-button"
          className="button button--small button--full"
          onClick={(event) => {
            event.stopPropagation();
            publishEvent({
              action: trackingAction,
              category: trackingCategory,
              label: trackingLabel,
              strainId: strain.id,
            });
          }}
        >
          shop menus
        </Link>
      )}
      {hasMenuItems === false && (
        <Link
          data-testid="strain-card-strain-link-button"
          className="button button--small button--full button--tertiary py-[6px]"
          onClick={(event) => {
            event.stopPropagation();
            publishEvent({
              action: trackingAction,
              category: trackingCategory,
              label: trackingLabel,
              strainId: strain.id,
            });
          }}
          href={`/strains/${strain.slug}`}
        >
          learn more
        </Link>
      )}
      {hasMenuItems === undefined && <ButtonPlaceholder height="36" />}
    </div>
  );
};

export default StrainCardAccessoryTray;
